export class Step2Data {
	constructor() { }

	public selectedWorkCity: number = -1;
	public selectedWorkStreet: number = -1;

	public isArmyService?: number = null;
	public isArmyServiceSelected?: boolean = null;

	public isLastArmyService?: boolean = null;
	public isLastArmyServiceSelected?: boolean = null;

	public isTavchin1Selected?: boolean = null;
	public isTavchin2?: boolean = null;
	public isTavchin2Selected?: boolean = null;
	public isTavchin3Selected?: boolean = null;
	public isTavchin4Selected?: boolean = null;

    public isTavchin5?: boolean = null;
    public isTavchin5Selected?: boolean = null;

    public isTavchin6Selected?: boolean = null;
	public isTavchin7Selected?: boolean = null;
	public isTavchin8Selected?: boolean = null;
	public isTavchin9Selected?: boolean = null;
	public isTavchin10Selected?: boolean = null;
    public isTavchin11Selected?: boolean = null;

    public isTavchin12?: boolean = null;
    public isTavchin12Selected?: boolean = null;

    ///public isTavchin13?: boolean = null;
    public isTavchin13Selected?: boolean = null;

    public isTavchin14?: boolean = null;
    public isTavchin14Selected?: boolean = null;

	public captchaToken: string = null;
}



// WEBPACK FOOTER //
// ./src/app/step2-calc/step2-DataModel.ts